import commonApiService from "./commonApiService.js";
import { getTokenHeader } from "../helpers/accessTokenHelper.js";

const getPages = async () => {
    try {
        const response = await commonApiService.apiPrivate().get('/pages', getTokenHeader());
        return response.data.data;
    } catch (error) {
        throw new Error(error.response?.data || 'Error al obtener las páginas');
    }
};

const saveOrUpdatePage = async (payload) => {
    try {
        const headers = getTokenHeader();

        if (payload.id) {
            const response = await commonApiService.apiPrivate().put(`/pages/${payload.id}`, payload, headers);
            return response.data;
        } else {
            const response = await commonApiService.apiPrivate().post('/pages', payload, headers);
            return response.data;
        }
    } catch (error) {
        throw new Error(error.response?.data || 'Error al guardar la página');
    }
};

const deletePage = async (id) => {
    try {
        const response = await commonApiService.apiPrivate().delete(`/pages/${id}`, getTokenHeader());
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data || 'Error al borrar la página');
    }
};

const getPage = async (id) => {
    try {
        const response = await commonApiService.apiPublic().get(`/pages/${id}`, getTokenHeader());
        return response.data.data;
    } catch (error) {
        throw new Error(error.response?.data || 'Error al obtener la p\u00e1gina p\u00fablica');
    }
};

const pagesService = {
    getPages,
    saveOrUpdatePage,
    deletePage,
    getPage
};

export default pagesService;